import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '../src/assets/css/global.css'
import axios from 'axios'
import global from '../src/global'

// 创建 Vue 应用实例
const app = createApp(App)

// 全局注册 Element Plus
app.use(ElementPlus)

// 配置 axios 到全局属性（Vue 3 方式）
app.config.globalProperties.$http = axios

// 配置全局函数插件
app.use(global)

// 使用路由和状态管理
app.use(router)
app.use(store)

// 关闭生产提示（Vue 3 默认无此配置，可忽略）
app.config.productionTip = false

// 挂载应用
app.mount('#app')
